<ng-container *ngIf="fullScreen">
  <div class="popover-overlay" *ngIf="show">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</ng-container>

<ng-container *ngIf="!fullScreen">
  <div class="line-loading" *ngIf="show">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</ng-container>
